import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { CondicaoDePagamento } from 'src/app/models/condicao-de-pagamento';
import { TipoVendaFormaPag } from 'src/app/models/enum';
import { FormaDePagamento } from 'src/app/models/forma-de-pagamento';
import { VendaFormaPag } from 'src/app/models/venda-forma-pag';
import { CarregandoService } from 'src/app/services/carregando.service';
import { CondicaoDePagamentoService } from 'src/app/services/condicao-de-pagamento.service';
import { FormaDePagamentoService } from 'src/app/services/forma-de-pagamento.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';

@Component({
  selector: 'app-cadastrar-multi-forma-pagamento-modal',
  templateUrl: './cadastrar-multi-forma-pagamento-modal.component.html',
  styleUrls: ['./cadastrar-multi-forma-pagamento-modal.component.scss']
})
export class CadastrarMultiFormaPagamentoModalComponent implements OnInit {

  forma: VendaFormaPag;
  valorMaximo: 0;
  formasDePagamento: FormaDePagamento[] = [];
  condicoesDePagamento: Array<{ disabled?: boolean } & CondicaoDePagamento> = [];
  fixo = false;
  pCentroDistribuicao = false;
  idCD;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private dialogRef: MatDialogRef<CadastrarMultiFormaPagamentoModalComponent>,
    private formaDePagamentoService: FormaDePagamentoService,
    private condicaoDePagamentoService: CondicaoDePagamentoService,
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.forma = data.forma;
    this.valorMaximo = data.valorMaximo;
    this.pCentroDistribuicao = data.pCentroDistribuicao;
    this.idCD = data.idCD;
    this.fixo = this.forma.tipo === TipoVendaFormaPag.Fixo;
  }

  ngOnInit(): void {
    this.buscarFormasDePagamento();
  }

  buscarFormasDePagamento() {
    this.carregandoService.mostra('buscaFormasDePagamento');
    this.formaDePagamentoService.consultar(1, this.fixo).subscribe(forms => {
      this.formasDePagamento = forms;

      if (this.pCentroDistribuicao) {
        this.formasDePagamento = forms.filter(forma => forma.fornecedores.length === 0 || forma.fornecedores.some(forn => forn === this.idCD));
      } else {
        this.formasDePagamento = forms;
      }

      if (!this.formasDePagamento.some(p => p.id === this.forma.idFormaPag)){
        this.forma.idFormaPag = undefined;
        this.forma.idCondPag = undefined;
      }

      if (this.forma.idFormaPag !== null && this.forma.idFormaPag !== undefined) {
        this.buscarCondicoesDePagamento();
      }
      this.carregandoService.esconde('buscaFormasDePagamento');
    }, (erro) => {
      this.carregandoService.esconde('buscaFormasDePagamento');
      this.notificacaoService.erro(erro);
    });


  }

  buscarCondicoesDePagamento() {
    if (this.forma.idFormaPag !== null && this.forma.idFormaPag !== undefined) {
      this.carregandoService.mostra('buscaCondicoesDePagamento');
      this.condicaoDePagamentoService.consultarPorForma(this.forma.idFormaPag, 1, this.fixo).subscribe(conds => {
        this.condicoesDePagamento = conds.map((cond) => {
          const foraDoLimite = this.condicaoDePagamentoService.verificaForaDoLimite(cond, this.valorMaximo);
          return { ...cond, disabled: foraDoLimite };
        });

        const selecionado = this.condicoesDePagamento.find((c) => c.idCondPag == this.forma.idCondPag);

        if (selecionado === undefined || selecionado === null) {
          this.forma.idCondPag = undefined;
        } else if (selecionado.disabled) {
          this.forma.idCondPag = undefined;
        }

        this.carregandoService.esconde('buscaCondicoesDePagamento');
      }, (erro) => {
        this.carregandoService.esconde('buscaCondicoesDePagamento');
        this.notificacaoService.erro(erro);
      });
    }
    else {
      this.condicoesDePagamento = [];
      this.forma.idCondPag = undefined;
    }
  }

  salvar() {
    this.forma.valor = Number(this.forma.valor);

    if (this.forma.valor > this.valorMaximo) {
      return;
    }

    const condPag = this.condicoesDePagamento.find(p => p.idCondPag === this.forma.idCondPag);

    this.forma.descricaoCondPag = condPag.descricao;
    this.forma.descricaoFormaPag = this.formasDePagamento.find(p => p.id === this.forma.idFormaPag).descricao;

    this.forma.taxa = condPag.taxaDA;

    this.forma.tipo = this.fixo ? TipoVendaFormaPag.Fixo : TipoVendaFormaPag.Variavel;

    this.dialogRef.close(this.forma);
  }

  fechar() {
    this.dialogRef.close();
  }
}
